import moment from 'moment';

/**
 * Calculates the age based on the provided birthdate.
 *
 * @param {string} birthdate - The birthdate in 'DD/MM/YYYY' format.
 * @returns {string} - The age in years or months.
 *
 * @example
 * calculateAge('25/03/1990'); // Returns '33 years'
 * calculateAge('10/10/2023'); // Returns '6 months'
 */
export const calculateAge = (birthdate) => {
    try {
        const birthdateMoment = moment(birthdate, 'DD/MM/YYYY');
        const now = moment();

        if (!birthdateMoment.isValid()) {
            throw new Error('Invalid birthdate format.');
        }

        const years = now.diff(birthdateMoment, 'years');
        const months = now.diff(birthdateMoment, 'months');

        if (years > 0) {
            return years === 1 ? `${years} Año` : `${years} Años`;
        } else {
            return months === 1 ? `${months} mes` : `${months} meses`;
        }
    } catch (error) {
        console.error('Invalid birthdate format. Please use DD/MM/YYYY.', error);
        return 'Invalid birthdate';
    }
};